import { TextField } from "@mui/material";
import React, { useEffect } from "react";
import { useRegion } from "./Hooks";

function CreateRegion({ set, data = {} }) {
  const {
    loading,
    citys,
    regions,
    provinec,
    getProvince,
    getRegion,
    getCity,
    setForm,
    form,
  } = useRegion(set, data);
  useEffect(() => {
    getProvince();
  }, []);
  return (
    <>
      {data && data.region && data.region[0] && (
        <div className="row">
          <div className="col">
            <h6>
              مقادیر قبلی :{" "}
              {`${data.province[0].name} - ${data.city[0].name} - ${data.region[0].name}`}
            </h6>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-md-4 col-12">
          <label htmlFor="">استان</label>
          <select
            onChange={({ target: { value } }) => getCity(value)}
            className="form-control"
            defaultValue={data.province_id}
          >
            <option value="">انتخاب کنید</option>
            {provinec.map((element, key) => (
              <option
                key={key}
                selected={form.province_id == element.id}
                value={element.id}
              >
                {element.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-4 col-12">
          <label htmlFor="">شهرستان</label>
          <select
            className="form-control"
            defaultValue={data.city_id}
            onChange={e => {
              setForm({ ...form, city_id: e.target.value });
            }}
          >
            <option value="">انتخاب کنید</option>

            {citys.map((element, key) => (
              <option
                key={key}
                selected={form.city_id == element.id}
                value={element.id}
              >
                {element.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-4 col-12">
          <label htmlFor="">منطقه</label>

          <TextField
            fullWidth
            // error={isLast && checkValidate(element.name)}
            label={"منطقه"}
            InputProps={
              {
                // className: styles.resize,
              }
            }
            // disabled={element.disabled}
            size="small"
            // defaultValue={element.value}
            // className={styles.textField}
            value={data.name}
            onChange={({ target: { value } }) => {
              set({
                ...data,
                name: value,
                province_id: form.province_id,
                city_id: form.city_id,
              });
            }}
          />
        </div>
      </div>
    </>
  );
}

export default CreateRegion;
